import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24f216d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "event_list"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Nenhum evento encontrado. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!
  const _component_ContentFallback = _resolveComponent("ContentFallback")!

  return (_ctx.userEvents.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userEvents, (event, index) => {
          return (_openBlock(), _createBlock(_component_Card, {
            key: index,
            event: event
          }, null, 8, ["event"]))
        }), 128))
      ]))
    : (_openBlock(), _createBlock(_component_ContentFallback, { key: 1 }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }))
}